import { render, staticRenderFns } from "./AccessRulesModalDelete.vue?vue&type=template&id=0797fb32&"
import script from "./AccessRulesModalDelete.vue?vue&type=script&lang=js&"
export * from "./AccessRulesModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports